function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import RichTextEditor from 'react-rte';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import CategoryData from './PpcProductCategory.context';
import PageBackButton from '../common/page/PageBackButton.react';
import PpcPageBanner from '../common/ppc/PpcPageBanner.react';
import PpcBreadcrumbs from '../common/ppc/PpcBreadcrumbs.react';
import PpcProductCategoryDetails from './product-category-details/PpcProductCategoryDetails.react';
import PpcProductCategoryParagraph from './product-category-details/PpcProductCategoryParagraph.react';
import SEO from '../common/page-components/SEO.react';
var PpcProductCategory = function PpcProductCategory() {
  var _useParams = useParams(),
    app = _useParams.app,
    categoryID = _useParams.categoryID;
  var dispatch = useDispatch();
  var categoryDetails = useSelector(function (s) {
    return s.ppc.product.category[categoryID];
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.productCategory,
      payload: {
        categoryID: categoryID
      }
    });
  }, [categoryID]);
  useEffect(function () {
    var _categoryDetails$para;
    if (!categoryDetails) return;
    setState(_objectSpread(_objectSpread(_objectSpread({}, state), categoryDetails), {}, {
      paragraph: ((_categoryDetails$para = categoryDetails.paragraph) === null || _categoryDetails$para === void 0 ? void 0 : _categoryDetails$para.length) > 0 ? RichTextEditor.createEmptyValue().setContentFromString(categoryDetails.paragraph, 'html') : RichTextEditor.createEmptyValue()
    }));
  }, [categoryDetails]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CategoryData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement(PpcProductCategoryDetails, null), /*#__PURE__*/React.createElement(PpcProductCategoryParagraph, null), /*#__PURE__*/React.createElement(PpcPageBanner, {
    id: categoryID,
    banner: state.banner || {},
    bannerType: "productCategory",
    disabled: state.archived,
    permission: "edit-".concat(app, "-products")
  }), /*#__PURE__*/React.createElement(PpcBreadcrumbs, {
    id: categoryID,
    type: "productCategory",
    breadcrumbs: state.breadcrumbs || {},
    disabled: state.archived,
    permission: "edit-".concat(app, "-products")
  }), /*#__PURE__*/React.createElement(SEO, {
    type: "ppcProductCategory",
    itemID: state._id || null,
    metadata: state.metadata || {},
    permission: "edit-".concat(app, "-products")
  }))));
};
export default PpcProductCategory;